// extracted by mini-css-extract-plugin
export default {"inputWrapper":"SearchInput_inputWrapper","icon":"SearchInput_icon","input":"SearchInput_input","reset":"SearchInput_reset"};